<router-outlet></router-outlet>

<footer class="footer">
    <p class="footer-copyright">&copy; {{year}} Iowa Farm Bureau | <a href="https://www.iowafarmbureau.com/">Return to Iowa Farm Bureau <fa-icon [icon]="faArrowRightLong"></fa-icon></a></p>
</footer>
